/**
 * @flow
 * @relayHash a839e46dd7b8c041e6fdc64da516674d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type approveHyeventInput = {|
  clientMutationId?: ?string,
  id: string,
|};
export type approveEventMutationVariables = {|
  input: approveHyeventInput
|};
export type approveEventMutationResponse = {|
  +approveHyevent: ?{|
    +clientMutationId: ?string,
    +hyevent: ?{|
      +id: string,
      +status: string,
    |},
  |}
|};
export type approveEventMutation = {|
  variables: approveEventMutationVariables,
  response: approveEventMutationResponse,
|};
*/


/*
mutation approveEventMutation(
  $input: approveHyeventInput!
) {
  approveHyevent(input: $input) {
    clientMutationId
    hyevent {
      id
      status
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "approveHyeventInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "approveHyevent",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "approveHyeventPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "hyevent",
        "storageKey": null,
        "args": null,
        "concreteType": "Hyevent",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "approveEventMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "approveEventMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "approveEventMutation",
    "id": null,
    "text": "mutation approveEventMutation(\n  $input: approveHyeventInput!\n) {\n  approveHyevent(input: $input) {\n    clientMutationId\n    hyevent {\n      id\n      status\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8a0520c0aa3f1b4069925e40201d213f';
module.exports = node;
